export default "__VITE_ASSET__B64t4Tw4__"